module.exports = __webpack_public_path__ + "static/media/bluntt.4603cadf.jpg";